import * as yup from 'yup'

export const propertyDetails = yup.object().shape({
  name: yup.string().required('Estate name is required'),
  address: yup.string().required('Estate address is required'),
  country: yup.string().required('country is required'),
  state: yup.string().required('state is required'),
  securityMeasures: yup.string(),
  amenities: yup.string(),
  surroundingInfrastructures: yup.string(),
})
